import React, { useState, useEffect } from 'react'
import { MuiThemeProvider, makeStyles, useTheme } from '@material-ui/core/styles'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Checkbox } from '@material-ui/core'

import { AddOutlined } from '@material-ui/icons'

import MaterialTable, { MTableCell, MTableToolbar } from '@material-table/core'
import { table } from '../../services/theme'
import clsx from 'clsx'
import { getStaffById } from '../../actions/Team/team.actions'
import useMarkets from '../../hooks/useMarkets'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		},
		marginLeft: 16
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		paddingLeft: 24,
		padding: '16px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	searchField: {
		minWidth: 350,
		paddingLeft: theme.spacing(2)
	},
	searchBy: {
		minWidth: 150,
		paddingLeft: theme.spacing(2),
		'& label': {
			transform: 'translate(28px, 14px) scale(1)'
		},
		'& svg': {
			top: 'calc(50% - 14px)',
			marginLeft: 23
		}
	},
	select: {
		paddingRight: '50px !important'
	}
}))

export const TeamTable = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()
	const params = useParams()
	const dispatch = useDispatch()
	const teamLoading = useSelector((state) => state.specific.team.loading)
	const facility = useSelector((state) => state.specific.facilities.selected)
	const staffList = useSelector((state) => state.specific.team.staffList)

	const [isDeactivatedShown, setisDeactivatedShown] = useState(false)
	const [activeStaff, setActiveStaff] = useState([])
	const { markets, marketIdToIndexMap } = useMarkets()

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (teamLoading) {
			setLoading(true)
		} else {
			setLoading(false)
		}
	}, [teamLoading])

	useEffect(() => {
		if (staffList) {
			setActiveStaff(staffList.filter((staff) => staff.active))
		}
	}, [staffList])

	const goToTeamMember = (teamMember) => {
		dispatch(getStaffById(teamMember._id)).then(() => {
			history.push(`/facilities/${facility._id}/team/${teamMember._id}`)
		})
	}

	return (
		<MuiThemeProvider theme={table}>
			<MaterialTable
				isLoading={loading}
				options={{
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2'
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left',
					searchFieldVariant: 'filled'
				}}
				columns={[
					{
						defaultSort: 'asc',
						title: 'Name',
						field: 'contact.full_name',
						cellStyle: {
							color: '#6B4AD6',
							fontWeight: 800
						}
					},
					{
						title: 'Phone',
						render: (rowData) =>
							rowData.active ? (
								<div style={{ color: '#1A1A35' }}>{rowData.contact.phone_number}</div>
							) : (
								<div style={{ color: '#777679' }}>{rowData.contact.phone_number}</div>
							)
					},
					{
						title: 'Email',
						render: (rowData) =>
							rowData.active ? (
								<div style={{ color: '#1A1A35' }}>{rowData.contact.email}</div>
							) : (
								<div style={{ color: '#777679' }}>{rowData.contact.email}</div>
							)
					},
					{
						title: 'Position',
						render: (rowData) =>
							rowData.active ? (
								<div style={{ color: '#1A1A35' }}>{rowData.position}</div>
							) : (
								<div style={{ color: '#777679' }}>{rowData.position}</div>
							)
					},
					{
						title: 'Status',
						field: 'active',
						render: (rowData) =>
							rowData.active ? (
								<div style={{ color: '#2E7B32' }}>Active</div>
							) : (
								<div style={{ color: '#777679' }}>Deactivated</div>
							)
					},
					{
						title: 'Market',
						render: (data) => {
							if (!data.market_id) {
								return 'Not Set'
							}
							const teamMarket = markets[marketIdToIndexMap[data.market_id]]
							return teamMarket?.city || 'Not Set'
						},
						customSort: (a, b) => {
							let aMarket = markets[marketIdToIndexMap[a.market_id]]
							let bMarket = markets[marketIdToIndexMap[b.market_id]]
							return aMarket?.city.localeCompare(bMarket?.city)
						},
						customFilterAndSearch: (value, data) => {
							if (!value) {
								return true
							}
							const teamMarket = markets[marketIdToIndexMap[data.market_id]]
							return teamMarket?.city?.toLowerCase().includes(value.toLowerCase())
						}
					}
				]}
				data={isDeactivatedShown ? staffList : activeStaff || []}
				onRowClick={(e, teamMember) => goToTeamMember(teamMember)}
				components={{
					Toolbar: (props) => (
						<div className={classes.toolbarWrapper}>
							{' '}
							<div className={classes.toolbar}>
								<MTableToolbar {...props} />
								<Button
									variant="outlined"
									className={clsx(classes.headerButton, classes.addClientButton)}
									startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
									size="large"
									onClick={() => history.push(`/facilities/${params.facilityId}/team/create`)}>
									Teammate
								</Button>
								<Checkbox
									checked={isDeactivatedShown}
									onChange={(e) => setisDeactivatedShown(!isDeactivatedShown)}
									label="Show Deactivated"
									style={{ marginLeft: '30px' }}
								/>
								Show Deactivated
								{/* Filter Button to be implemented later */}
								{/* <Button
                  variant="outlined"
                  startIcon={<i className="fa fa-sliders-h" />}
                  size="medium"
                ></Button> */}
							</div>
						</div>
					),
					Cell: (props) => (
						<MTableCell
							style={{
								fontSize: '16px',
								lineHeight: '22px',
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					)
				}}
				title="Team"
			/>
		</MuiThemeProvider>
	)
}
